import { render, staticRenderFns } from "./photoScan.vue?vue&type=template&id=9aa29498&scoped=true"
import script from "./photoScan.vue?vue&type=script&lang=js"
export * from "./photoScan.vue?vue&type=script&lang=js"
import style0 from "./photoScan.vue?vue&type=style&index=0&id=9aa29498&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa29498",
  null
  
)

export default component.exports